import { Injectable, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly _router = inject(Router);

  constructor() {}

  public redirectToCrear = signal('');
  public redirectToVisualizar = signal('');
  public redirectToEditar = signal('');
  public redirectToSecciones = signal('');
  public breadcrumbs = signal<string>('');

  extractPath(basePath: string): void {
    const url = this._router.url;
    const urlArray = url.split('/');
    const urlArrayLength = urlArray.length;
    const id = urlArray[urlArrayLength - 1];

    this.breadcrumbs.set(`${urlArray[urlArrayLength - 2]}/${urlArray[urlArrayLength - 1]}`);
    this.redirectToSecciones.set(`/${basePath}/${id}`);
    this.redirectToCrear.set(`/${basePath}/${id}/crear`);
    this.redirectToEditar.set(`/${basePath}/${id}/editar`);
    this.redirectToVisualizar.set(`/${basePath}/${id}/visualizar`);
  }

  extractPathWithId(basePath: string): void {
    const url = this._router.url;
    const urlArray = url.split('/');
    const urlArrayLength = urlArray.length;
    const id = urlArray[urlArrayLength - 1];

    this.breadcrumbs.set(`${urlArray[urlArrayLength - 2]}/${urlArray[urlArrayLength - 1]}`);
    this.redirectToSecciones.set(`/${basePath}/${id}`);
    this.redirectToCrear.set(`/${basePath}/${id}/crear`);
    this.redirectToEditar.set(`/${basePath}/${id}/editar`);
    this.redirectToVisualizar.set(`/${basePath}/${id}/visualizar`);
  }
}
